import React from "react";
import { Button, Alert } from "antd";
import { alredyRegisteredText } from "../../../../constants";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import FormHeader from "swfrontend/MDM/MDMScreens/FormView/FormHeader";
import Instructions from "./Instructions";

class CustomHeader extends React.Component {
  render() {
    const {
      isInEdit,
      goToLogin,
      agreeToIns,
      onBackPressed,
      formRef,
      disabled,
      showSave,
      isStaff,
      customer_sap_code,
      showLogin,
    } = this.props;

    return !isInEdit && !isStaff ? (
      <>
        {showLogin && (
          <div className="row form-box already-registered p-3">
            <div className="col-lg-6">
              <b className="text-left">{alredyRegisteredText}</b>
            </div>
            <div className="col-lg-6 text-right">
              <Button type="primary" onClick={goToLogin}>
                Go To Login
              </Button>
            </div>
          </div>
        )}

        <Instructions onChange={agreeToIns} />
      </>
    ) : showSave ? (
      <>
        <div
          hidden={
            (customer_sap_code === null || customer_sap_code === "")
              ? true
              : false
          }
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "10px",
            borderRadius: "5px",
          }}
        >
          <Alert
            message={"Customer Sap Code : " + customer_sap_code}
            type="success"
            showIcon
          />
        </div>

        <FormHeader
          showSaveButton={!disabled}
          showBackButton={disabled}
          onBackPressed={onBackPressed}
          editDataAvailable={true}
          formRef={formRef}
        />
      </>
    ) : (
      <>
        <div
          hidden={
            (customer_sap_code === null || customer_sap_code === "")
              ? true
              : false
          }
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "10px",
            borderRadius: "5px",
          }}
        >
          <Alert
            message={"Customer Sap Code : " + customer_sap_code}
            type="success"
            showIcon
          />
        </div>

        <div
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "10px",
            borderRadius: "5px",
          }}
        >
          <Alert
            message="Your request is under approval"
            type="warning"
            showIcon
          />
        </div>
      </>
    );
  }
}

export default CustomHeader;
